import { Badge } from '@bbpos/ui';
import type { RfqResponseStatus, RfqStatus } from './types';

type BadgeVariant = 'draft' | 'ordered' | 'success' | 'danger' | 'partial';

const STATUS_MAP: Record<RfqStatus, { label: string; variant: BadgeVariant }> = {
  DRAFT: { label: 'Draft', variant: 'draft' },
  SENT: { label: 'Sent', variant: 'ordered' },
  CLOSED: { label: 'Closed', variant: 'success' },
  CANCELLED: { label: 'Cancelled', variant: 'danger' },
};

const RESPONSE_MAP: Record<RfqResponseStatus, { label: string; variant: BadgeVariant }> = {
  PENDING: { label: 'Pending', variant: 'partial' },
  QUOTED: { label: 'Quoted', variant: 'success' },
  DECLINED: { label: 'Declined', variant: 'danger' },
};

export function RfqStatusBadge({ status, size = 'sm' }: { status: RfqStatus; size?: 'sm' | 'md' }) {
  const meta = STATUS_MAP[status] ?? STATUS_MAP.DRAFT;
  return (
    <Badge variant={meta.variant} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {meta.label}
      </span>
    </Badge>
  );
}

export function RfqResponseBadge({ status, size = 'sm' }: { status: RfqResponseStatus; size?: 'sm' | 'md' }) {
  const meta = RESPONSE_MAP[status] ?? RESPONSE_MAP.PENDING;
  return (
    <Badge variant={meta.variant} size={size}>
      {meta.label}
    </Badge>
  );
}
